export default __webpack_public_path__ + "static/media/anime-typing.55f53559.gif";